import { useState, useEffect } from "react";
import { Box, Grid, GridItem, VStack, Button, Text } from "@chakra-ui/react";
import DynamicFormContainer from "components/CommonForm/DynamicFormContainer";
import ProfileCard from "components/CommonForm/ProfileCard";

const formConfig = [
    {
        id: "productInfo",
        title: "Product Information",
        fields: [
            { name: "productName", label: "Product Name", type: "text", required: true, gridSize: 6 },
            {
                name: "unitOfMeasure",
                label: "Unit of Measure",
                type: "select",
                options: ["Box", "Kg", "Pieces"],
                required: true,
                gridSize: 6
            },
            { name: "price", label: "Price", type: "number", required: true, gridSize: 6 },
            { name: "description", label: "Description", type: "textarea", required: false, gridSize: 12 },
        ],
    },
];

const AddProduct = ({ productData }) => {
    const [formData, setFormData] = useState({
        productName: productData?.productName || "",
        unitOfMeasure: productData?.unitOfMeasure || "",
        price: productData?.price || "",
        description: productData?.description || "",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (productData) {
            setFormData((prevData) => ({
                ...prevData,
                productName: productData.productName || prevData.productName,
                unitOfMeasure: productData.unitOfMeasure || prevData.unitOfMeasure,
                price: productData.price ? parseFloat(productData.price.replace("€", "")) : prevData.price,
                description: productData.description || prevData.description,
            }));
        }
    }, [productData]);


    const validateForm = () => {
        let newErrors = {};
        formConfig[0].fields.forEach((field) => {
            if (field.required && !formData[field.name]) {
                newErrors[field.name] = "This field is required";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            console.log("Final Payload:", JSON.stringify(formData, null, 2));
        }
    };
    console.log(productData, "productData")

    return (
        <Box  mt={24}>
            <ProfileCard name={formData.productName || "Product Name"} profileImage="" status="Available" />
            <Grid mt={4} templateColumns="1fr" gap={6} alignItems="start">
                <GridItem>
                    <VStack spacing={6} align="stretch">
                        <DynamicFormContainer
                            key={formConfig[0].id}
                            title={formConfig[0].title}
                            cardData={formConfig[0]}
                            formData={formData}
                            setFormData={setFormData}
                            errors={errors}
                        />
                    </VStack>
                </GridItem>
            </Grid>

            {Object.keys(errors).length > 0 && (
                <Text color="red.500" mt={4}>
                    Please fix the errors before submitting.
                </Text>
            )}

            <Button mt={6} bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                w="125px"
                h="35px"
                color="#fff"
                fontSize="xs"
                fontWeight="bold"
                alignSelf={{ sm: "flex-start", lg: null }}
                mb={{ sm: "12px", md: "0px" }} onClick={handleSubmit}>
                Add Product
            </Button>
        </Box>
    );
};

export default AddProduct;
